import { CircularProgress } from "@mui/material";

import { useMemo } from "react";

import { authSelector } from "@/pages/Public/redux/auth.slice";

import { useAppSelector } from "@/redux/hooks";

import { Role } from "@/enum";

import { CourseStatus } from "../../enums/CourseStatus.enum";
import { Courses } from "../../schema/courses";
import CourseContainerItem from "./CourseContainerItem";

interface ICourseContainerProps {
	coursesInfo: Courses[];
	isLoading?: boolean;
}

export default function CourseContainer({ coursesInfo, isLoading }: ICourseContainerProps) {
	const auth = useAppSelector(authSelector);

	// Drafts are the global admin's alone; everything published is shown in every language —
	// the language filter is the reader's choice on the overview, not the profile's (BCM360-342).
	const preparedCourses = useMemo(() => {
		return coursesInfo
			?.filter((courseInfo) => {
				if (courseInfo?.status === CourseStatus.Draft) {
					return auth?.user?.role?.code === Role.GLOBAL_ADMIN;
				}

				return courseInfo?.status === CourseStatus.Active;
			})
			.map((courseInfo) => <CourseContainerItem key={courseInfo.id} courseInfo={courseInfo} />);
	}, [auth, coursesInfo]);

	return (
		<>
			{isLoading ? (
				<div className="w-full flex-1 flex items-center justify-center">
					<CircularProgress className="!w-16 !h-16 !text-primary-gray" />
				</div>
			) : (
				<div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 w-full gap-4">
					{preparedCourses}
				</div>
			)}
		</>
	);
}
